/** Promise-based prompt hostowany w UI (SchedulePage), zamiast window.confirm. */

let pendingResolve = null;

/**
 * @param {{
 *   mode?: 'confirm' | 'info',
 *   title?: string,
 *   message?: string,
 *   items?: Array<{ name: string, reason?: 'assigned'|'unavailable' }>,
 *   date?: string,
 *   durationMs?: number,
 *   confirmQuestion?: string,
 * }} payload
 * @returns {Promise<boolean>} true = potwierdź / OK, false = anuluj (tylko confirm)
 */
export function requestStaffConflictPrompt(payload) {
    if (typeof window === 'undefined') return Promise.resolve(true);

    if (payload?.mode === 'info') {
        window.dispatchEvent(new CustomEvent('planner:staffConflictPrompt', { detail: payload }));
        return Promise.resolve(true);
    }

    return new Promise((resolve) => {
        pendingResolve = resolve;
        window.dispatchEvent(new CustomEvent('planner:staffConflictPrompt', {
            detail: { mode: 'confirm', ...payload },
        }));
    });
}

export function answerStaffConflictPrompt(accepted) {
    if (pendingResolve) {
        pendingResolve(!!accepted);
        pendingResolve = null;
    }
}

export function dismissStaffConflictPrompt() {
    answerStaffConflictPrompt(false);
}

export function notifyStaffConflictInfo(message, durationMs = 4000) {
    return requestStaffConflictPrompt({
        mode: 'info',
        title: 'Konflikt zajętości',
        message: message || 'Konflikt zajętości',
        durationMs,
    });
}
